import { regex } from './common'
export default regex('decimal', /^[-]?\d*(\.\d+)?$/)



// WEBPACK FOOTER //
// ./src/assets/validity/validators/decimal.js